/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkCenterTaskAffectedTimes } from '../../models/work-center-task-affected-times';

export interface GetAffectedTimes$Params {
  workCenterTaskId: number;
}

export function getAffectedTimes(http: HttpClient, rootUrl: string, params: GetAffectedTimes$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkCenterTaskAffectedTimes>> {
  const rb = new RequestBuilder(rootUrl, getAffectedTimes.PATH, 'get');
  if (params) {
    rb.path('workCenterTaskId', params.workCenterTaskId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkCenterTaskAffectedTimes>;
    })
  );
}

getAffectedTimes.PATH = '/api/v1/Tasks/{workCenterTaskId}/AffectedTimes';
